export default __webpack_public_path__ + "static/media/unavailable.a9fdffba.png";